import { useChargeMockPirata } from "@/hooks/useRefundN8N";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    Flex,
    Image
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const ConfirmeModal = ({ setOpenResponseModal, setResponseModal, openModal, setOpenModal, amount }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { solicitationRefund } = useChargeMockPirata()

    const { id } = useParams();
    useEffect(() => {
        if (openModal) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [openModal]);

    const handleClose = () => {
        setIsOpen(false);
        setOpenModal(false)
    };

    async function getResponse() {
        try {

            const data = { value: Number(amount) }

            const response = await solicitationRefund(id, data)
            setResponseModal(response)
            setOpenResponseModal(true)
            setOpenModal(false)
        } catch (error) {
            setResponseModal({ ...error.response.data[0].errors[0], error: true })

            setOpenResponseModal(true)
            setOpenModal(false)
        }
    }

    const formattedAmount = Number(amount) > 0 ? Number(amount).toFixed(2) : "0.00";

    return (
        <Modal isOpen={isOpen} onClose={handleClose} isCentered>

            <ModalOverlay />
            <ModalContent maxW="520px">
                <Flex
                    p="32px 32px 24px 32px"
                    alignContent="initial"
                    alignItems={"flex-start"}
                >
                    <Image
                        w="24px"
                        h="24px"
                        src="/images/icons/ExclamationCircle.svg" />
                    <Flex
                        flexDirection="column"
                    >

                        <ModalHeader
                            p="0 24px"
                        >Deseja estornar essa cobrança?</ModalHeader>
                        <ModalBody>
                            <Text fontSize="sm" mt={1}>
                                {` Será estornado o valor de R$ ${formattedAmount} e essa ação não poderá ser desfeita.`}
                            </Text>
                        </ModalBody>
                        <ModalFooter p="0 32px" gap="8px">
                            <Button
                                variant="outline"
                                onClick={handleClose}
                                borderRadius="2px"
                                fontSize="14px"
                                w="93px"
                                h="32px"
                            >
                                Cancelar
                            </Button>
                            <Button
                                w="90px"
                                h="32px"
                                borderRadius="2px"
                                fontSize="14px"
                                color="white"
                                backgroundColor="#CB2159"
                                onClick={() => getResponse()}
                            >
                                Estornar
                            </Button>
                        </ModalFooter>
                    </Flex>

                </Flex>
            </ModalContent>
        </Modal>
    );
};
